import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Spinner, SpinnerTypes, Text} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {classes} from './loader.st.css'

export const Loader = () => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()
  const id = 'seating-plan-checkout-loader'

  useEffect(() => {
    focusElement({selector: hookToAttributeSelector(DH.SEATINGS_LOADER_CONTENT)})
  }, [])

  const ignoreTab = e => {
    if (e.key === 'Tab') {
      e.preventDefault()
    }
  }

  return (
    <div
      className={classes.container}
      aria-modal="true"
      aria-labelledby={id}
      role="dialog"
      data-hook={DH.SEATINGS_LOADER}
    >
      <div
        data-hook={DH.SEATINGS_LOADER_CONTENT}
        className={classNames(classes.content, {[classes.desktopContent]: !isMobile})}
        onKeyDown={ignoreTab}
      >
        <div className={classes.text} id={id}>
          <Text
            data-hook={DH.MODAL_TITLE}
            tagName="h2"
            className={classNames(classes.title, {[classes.mobileTitle]: isMobile})}
          >
            {t('seatings_loader_title')}
          </Text>
          <Text data-hook={DH.MODAL_TEXT} className={classes.subtitle}>
            {t('seatings_loader_subtitle')}
          </Text>
        </div>
        <div aria-hidden={true}>
          <Spinner type={SpinnerTypes.slim} className={classes.spinner} />
        </div>
      </div>
    </div>
  )
}
